module.exports = __webpack_public_path__ + "img/dummy-user-img.b76dbdfa.png";